import globals from "@homer.core/globals";

document.querySelectorAll("head > style[id]").forEach((node) => {
    globals.demand.provide(node.id, () => node);
});

export default {
    obtain: (id) => {
        return globals.demand.request(id);
    },
};
